import BiX from '@meronex/icons/bi/BiX';
import icon from './StyledIcon';
export default icon(BiX);
